var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05 28.913zm0 0L9.9 23.77 16 13.197V3c-.16 0-.322.106-.444.317L8.33 15.844 1.104 28.37c-.121.212-.133.403-.053.543zM16 13.196l6.1 10.575H9.9l-8.85 5.143c.08.14.252.227.496.227h28.907c.245 0 .416-.087.496-.227.08-.14.067-.331-.054-.543L23.67 15.844 16.444 3.317C16.322 3.106 16.16 3 16 3v10.196z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat);
export default __webpack_public_path__ + "static/media/BAT.36d0f4b55c2dd2941ae8adca45898a9d.svg";
export { ForwardRef as ReactComponent };